import { render } from "./SceltaVeicolo.vue?vue&type=template&id=17fbe39c&scoped=true"
import script from "./SceltaVeicolo.vue?vue&type=script&lang=js"
export * from "./SceltaVeicolo.vue?vue&type=script&lang=js"

import "./SceltaVeicolo.vue?vue&type=style&index=0&id=17fbe39c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17fbe39c"]])

export default __exports__